"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopoverAndOverlay = PopoverAndOverlay;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function PopoverAndOverlay(_ref) {
  var {
    text,
    fieldName
  } = _ref;
  var popoverService = /*#__PURE__*/_react.default.createElement(_reactBootstrap.Popover, {
    id: "popover".concat(fieldName)
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Popover.Content, null, /*#__PURE__*/_react.default.createElement("p", null, " ", text, " ")));
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.OverlayTrigger, {
    trigger: "click",
    placement: "bottom",
    rootClose: true // Dismisses the popover when on an outside click
    ,
    overlay: popoverService
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    variant: "none",
    "aria-label": fieldName + ' popover',
    className: "btn-inline"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-info"
  })));
}